import { graphql, Link, StaticQuery } from "gatsby"
import Img from "gatsby-image"
import React from "react"

const Badge: React.FC<{ width: number }> = ({ width }) => {
  const style = { width }
  const gqlQueryAppLogo_FluidImage = graphql`
    query {
      placeholderImage: file(relativePath: { eq: "badge.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `

  return (
    <StaticQuery query={gqlQueryAppLogo_FluidImage}>
      {data => (
        <Link to={"/"}>
          <div className="bg-white rounded-full">
            <Img
              style={style}
              alt={"Badge"}
              fluid={data.placeholderImage.childImageSharp.fluid}
            />
          </div>
        </Link>
      )}
    </StaticQuery>
  )
}

export default Badge
